// Module
var code = "<h2 id=\"understanding-student-loan-forgiveness\">Understanding Student Loan Forgiveness</h2> <p>You may qualify to have some or all of your federal student loans forgiven. Whether it&#39;s forgiveness, cancellation, or discharge, they all lead to the same outcome&mdash;debt relief. Explore StudentAid.gov for more information.</p> ";
// Exports
export default code;